document.addEventListener('DOMContentLoaded', function() {
  
  const isProductPage = document.body.classList.contains('template-product') || 
                       window.location.pathname.includes('/products/') ||
                       document.querySelector('.product');
  
  
  if (isProductPage) {
    function copyFAQContent() {
      const sourceContainer = document.querySelector('.efaq-container');
      const targetContainer = document.getElementById('efaq-container-all');
      
      if (!sourceContainer || !targetContainer) {
        return false;
      }
      
      // Check if the FAQ content has been rendered (look for actual FAQ items)
      const faqItems = sourceContainer.querySelectorAll('[class*="faq"], [class*="question"], [class*="answer"], .accordion, details, summary');
      
      if (faqItems.length === 0) {
        return false;
      }
      
      // Wait a bit more for Alpine.js to fully render the content
      setTimeout(() => {
        try {
          // Create a static copy without dynamic attributes
          const staticContent = createStaticCopy(sourceContainer);
          targetContainer.innerHTML = staticContent;
          
          // Hide the h4.efaq-title in the copied version
          const copiedTitle = targetContainer.querySelector('h4.efaq-title');
          if (copiedTitle) {
            copiedTitle.style.display = 'none';
          }
        } catch (error) {
        }
      }, 1000);
      
      return true;
    }
    
    function createStaticCopy(element) {
      // Clone the element
      const clone = element.cloneNode(true);
      
      // Remove all Alpine.js and dynamic attributes
      const allElements = [clone, ...clone.querySelectorAll('*')];
      allElements.forEach(el => {
        const attributesToRemove = [];
        for (let attr of el.attributes || []) {
          if (attr.name.startsWith('x-') || 
              attr.name.startsWith('@') || 
              attr.name.startsWith(':') ||
              attr.name === '_x_datastack' ||
              attr.name === '_x_bindings') {
            attributesToRemove.push(attr.name);
          }
        }
        attributesToRemove.forEach(attrName => el.removeAttribute(attrName));
        
        // Remove Alpine.js generated IDs and classes that might cause conflicts
        if (el.id && el.id.match(/^alpine-\d+$/)) {
          el.removeAttribute('id');
        }
      });
      
      return clone.innerHTML;
    }

    let attempts = 0;
    const maxAttempts = 50;
    const checkInterval = 200;

    function waitAndCopy() {
      attempts++;
      
      if (copyFAQContent()) {
        return;
      }
      
      if (attempts < maxAttempts) {
        setTimeout(waitAndCopy, checkInterval);
      }
    }

    setTimeout(waitAndCopy, 500);
  }
});
